<template>
    <div class="app">
        <Loading :value="loading"></Loading>
        <!-- RACOURCIS -->
        <v-card>
            <v-card-title>
                <v-breadcrumbs icons divider="chevron_right">
                    <v-breadcrumbs-item icons router :to='item.path' v-for="(item,ind) in racourcis" :key="ind" :disabled="item.disabled"> {{ item.text }}</v-breadcrumbs-item>
                </v-breadcrumbs>
            </v-card-title>
        </v-card>
        <br/>

        <v-layout row >
            <v-flex sm12 ml-1 mr-1 mt-1>
                <v-card>
                    <el-tabs stretch="true" v-model="onglet" type="border-card" @tab-click="handleTabClick(onglet)" >
                        <!--validation facture-->
                        <el-tab-pane label=" Confirmation paiement des factures">
                            <facturePaiement></facturePaiement>
                        </el-tab-pane>

                        <!--confirmation paiement facture-->
                        <el-tab-pane label=" Validation devis / facture & Demande d'absence">
                            <!--Ligne 1 -->
                            <v-layout row class="mb-4">
                                <!-- TABLE DEMANDE -->
                                <v-flex xs6 class="mr-3" >
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title>{{legendeDmd}}</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title class="text-xs-center">
                                            <v-layout wrap>
                                                <!-- <v-flex xs12 >
                                                    <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                        <span class="subheading">Montant total des demandes de maintenances à validée(s): </span> <span class="title"> {{mntTTCAValide}} Fcfa </span>
                                                    </v-chip>
                                                </v-flex> -->

                                                <v-flex xs4 class="mb-3" >
                                                    <v-chip color="orange" text-color="white" style="font-size:18px">
                                                        <v-avatar class="orange darken-4">{{nbDmdMaint}}</v-avatar>
                                                        Maintenances à valider
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs12 >
                                                    <v-layout row class="mb-3" >
                                                        <v-flex xs5  >
                                                            <el-select clearable @clear="clearSelectDmdZone()"  filterable  @change="filtrerZoneDmd" v-model="selectZoneDmd" placeholder="Demande par zone" style="width:100%">
                                                                <el-option
                                                                        v-for="(item,ind) in comboZoneDmd"
                                                                        :key="ind"
                                                                        :label="item.text"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>


                                                <v-flex xs12>
                                                    <data-tables :data="listeDemandes" >
                                                        <el-table-column prop="date" label="Date" > </el-table-column>
                                                        <el-table-column prop="nomDemandeur" label="demandeur" ></el-table-column>
                                                        <!-- <el-table-column prop="mntFacture" label="Montant Fcfa">
                                                            <template slot-scope="scope">
                                                               <el-tag  >{{scope.row.mntFacture}}</el-tag>
                                                           </template>
                                                        </el-table-column> -->
                                                        <el-table-column prop="libZone" label="Zone" > </el-table-column>
                                                        <el-table-column prop="libPriorite" label="Priorité" >
                                                            <template slot-scope="scope">
                                                                <el-tag v-if="scope.row.etat == 3" type="info" >{{scope.row.libPriorite}}</el-tag>
                                                                <el-tag v-if="scope.row.priorite == 0" type="info">  {{scope.row.libPriorite}}</el-tag>
                                                                <el-tag v-if="scope.row.priorite == 1" >{{scope.row.libPriorite}}</el-tag>
                                                                <el-tag v-if="scope.row.priorite == 2" type="warning" >{{scope.row.libPriorite}}</el-tag>
                                                                <el-tag v-if="scope.row.priorite == 3" type="danger" >{{scope.row.libPriorite}}</el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="Action" align="center" fixed="right"  >
                                                            <template slot-scope="scope">
                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="modalDetailDmd(scope.row)" fab dark small color="blue">
                                                                        <v-icon dark>list</v-icon>
                                                                    </v-btn>
                                                                    Detail
                                                                </v-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>


                                        </v-card-title>

                                    </v-card>
                                </v-flex>

                                <!-- TABLE MISSION -->
                                <v-flex xs6>
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title   >{{legendeMiss}}</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title class="text-xs-center">
                                            <v-layout wrap>
                                                <v-flex xs12 >
                                                    <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                        <span class="subheading">Montant total des demandes de mission à validées: </span> <span class="title"> {{mntTotalMissTTC}} Fcfa </span>
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex xs4 class="mb-3" >
                                                    <v-chip color="orange" text-color="white" style="font-size:18px">
                                                        <v-avatar class="orange darken-4">{{nbMiss}}</v-avatar>
                                                        Missions à  valider
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex xs12 >
                                                    <v-layout row class="mb-3" >
                                                        <v-flex xs5  >
                                                            <el-select clearable @clear="clearSelectMissDemd()"  filterable  @change="filtrerMissDemd" v-model="selectMissDemd" placeholder="Mission par demandeur" style="width:100%">
                                                                <el-option
                                                                        v-for="(item,ind) in listeDemandeurs"
                                                                        :key="ind"
                                                                        :label="item.text"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>



                                                <v-flex xs12>
                                                    <data-tables :data="listeMissions" >
                                                        <el-table-column prop="date" label="Date" > </el-table-column>
                                                        <el-table-column prop="demandeur" label="demandeur" ></el-table-column>
                                                        <el-table-column prop="budget" label="Budget (Fcfa)">
                                                            <template slot-scope="scope">
                                                                <el-tag  >{{scope.row.budget}}</el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="activite" label="Activite" > </el-table-column>
                                                        <el-table-column label="Action" align="center" fixed="right"  >
                                                            <template slot-scope="scope">
                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="modalDetailMissDemd(scope.row)" fab dark small color="blue">
                                                                        <v-icon dark>list</v-icon>
                                                                    </v-btn>
                                                                    Detail
                                                                </v-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>


                                        </v-card-title>

                                    </v-card>
                                </v-flex>
                            </v-layout>

                            <!--Ligne 2 -->
                            <v-layout row class="mb-4">
                                <!-- TABLE DEMANDE -->
                                <v-flex xs6 class="mr-3" >
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title   >{{legendeFour}}</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title class="text-xs-center">
                                            <v-layout wrap>
                                                <v-flex xs12 >
                                                    <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                        <span class="subheading">Montant total des factures  à valider: </span>&nbsp; <span class="title"> {{ new Intl.NumberFormat().format(mntTotalFactTTC) }} Fcfa </span>
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs4 class="mb-3" >
                                                    <v-chip color="orange" text-color="white" style="font-size:18px">
                                                        <v-avatar class="orange darken-4">{{nbFactFour}}</v-avatar>
                                                        Factures à valider
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs12 >
                                                    <v-layout row class="mb-3" >
                                                        <v-flex xs5  >
                                                            <el-select clearable @clear="clearSelectFour()"  filterable  @change="filtrerFour" v-model="selectFour" placeholder="Facture par fournisseur" style="width:100%">
                                                                <el-option
                                                                        v-for="(item,ind) in listeFournisseurs"
                                                                        :key="ind"
                                                                        :label="item.text"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>


                                                <v-flex xs12>
                                                    <data-tables :data="listeFacturesFour" >
                                                        <el-table-column prop="date" label="Date" > </el-table-column>
                                                        <el-table-column prop="ref" label="Référence" ></el-table-column>
                                                        <el-table-column prop="libelle" label="Libellé"> </el-table-column>
                                                        <el-table-column prop="total" label="Montant" >
                                                            <template slot-scope="scope">
                                                                <el-tag>{{new Intl.NumberFormat('fr-Fr').format(scope.row.total)}}</el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="libelleFour" label="Fournisseur" ></el-table-column>
                                                        <el-table-column label="Action" align="center" fixed="right"  >
                                                            <template slot-scope="scope">
                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="modalDetailFour(scope.row)" fab dark small color="blue">
                                                                        <v-icon dark>list</v-icon>
                                                                    </v-btn>
                                                                    Detail
                                                                </v-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>


                                        </v-card-title>

                                    </v-card>
                                </v-flex>

                                <v-flex xs6 class="mr-3" >
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title>{{legendeInterv}}</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title class="text-xs-center">
                                            <v-layout wrap>
                                                <v-flex xs12 >
                                                    <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                        <span class="subheading">Montant total des réparations à valider: </span> <span class="title"> {{mntTotalIntervTTC}} Fcfa </span>
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs4 class="mb-3" >
                                                    <v-chip color="orange" text-color="white" style="font-size:18px">
                                                        <v-avatar class="orange darken-4">{{nbInterv}}</v-avatar>
                                                        Intervention à valider
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs12 >
                                                    <v-layout row class="mb-3" >
                                                        <v-flex xs5  >
                                                            <el-select clearable @clear="clearSelectInterv()"  filterable  @change="filtrerInterv" v-model="selectInterv" placeholder="Intervention par demandeur" style="width:100%">
                                                                <el-option
                                                                        v-for="(item,ind) in listeDemdInterv"
                                                                        :key="ind"
                                                                        :label="item.text"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>


                                                <v-flex xs12>
                                                    <data-tables :data="listeIntervention" >
                                                        <el-table-column prop="date" label="Date" > </el-table-column>
                                                        <el-table-column prop="IdInterv" label="Référence" ></el-table-column>
                                                        <el-table-column prop="garage" label="Garage"> </el-table-column>
                                                        <el-table-column prop="mntTotCom" label="Montant(fcfa)" >
                                                            <template slot-scope="scope">
                                                                <el-tag>{{new Intl.NumberFormat().format(scope.row.mntTotCom)}}</el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column prop="demandeur" label="Demandeur" ></el-table-column>
                                                        <el-table-column prop="priorite" label="Priorité" >
                                                            <template slot-scope="scope">
                                                                <el-tag v-if="scope.row.priorite == 'Moins urgent'" type="info">  {{scope.row.priorite}}</el-tag>
                                                                <el-tag v-if="scope.row.priorite == 'Urgent'" type="warning" >{{scope.row.priorite}}</el-tag>
                                                                <el-tag v-if="scope.row.priorite == 'Très urgent'" type="danger" >{{scope.row.priorite}}</el-tag>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="Action" align="center" fixed="right"  >
                                                            <template slot-scope="scope">
                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="modalDetailInterv(scope.row)" fab dark small color="blue">
                                                                        <v-icon dark>list</v-icon>
                                                                    </v-btn>
                                                                    Detail
                                                                </v-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>


                                        </v-card-title>
                                    </v-card>
                                </v-flex>
                            </v-layout>


                            <!--Ligne 3 -->
                            <v-layout row>
                                <!-- TABLE DEMANDE DE FONDS -->
                                <v-flex xs6 class="mr-3" >
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title   >{{legendeDmdFond}}</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title class="text-xs-center">
                                            <v-layout wrap>
                                                <v-flex xs12 >
                                                    <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                        <span class="subheading">Montant total  à valider: </span> <span class="title"> {{mntTotalDmdFondTTC}} Fcfa </span>
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs4 class="mb-3" >
                                                    <v-chip color="orange" text-color="white" style="font-size:18px">
                                                        <v-avatar class="orange darken-4">{{nbDmdFond}}</v-avatar>
                                                        Demande de fonds à valider
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs12 >
                                                    <v-layout row class="mb-3" >
                                                        <v-flex xs5  >
                                                            <el-select clearable @clear="clearSelectFour()"  filterable  @change="filtrerDmdFond" v-model="selectDmdFond" placeholder="Demandeur" style="width:100%">
                                                                <el-option
                                                                        v-for="(item,ind) in listeDemandeurFond"
                                                                        :key="ind"
                                                                        :label="item.text"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>


                                                <v-flex xs12>
                                                    <data-tables :data="listeDmdFond" >
                                                        <el-table-column prop="dateFormat" label="Date" > </el-table-column>
                                                        <el-table-column prop="demandeur" label="Nom du demandeur" ></el-table-column>
                                                        <el-table-column prop="montantFormat" label="Montant (Fcfa)"> </el-table-column>
                                                        <el-table-column prop="typeDmd" label="Type demande"> </el-table-column>
                                                        <el-table-column label="Action" align="center" fixed="right"  >
                                                            <template slot-scope="scope">
                                                                <v-tooltip top>
                                                                    <v-btn slot="activator" @click="modalDetailDmdFond(scope.row)" fab dark small color="blue">
                                                                        <v-icon dark>list</v-icon>
                                                                    </v-btn>
                                                                    Detail
                                                                </v-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </data-tables>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-title>

                                    </v-card>
                                </v-flex>

                                <!-- TABLE APPROVISIONNEMENT -->
                                <v-flex xs6 class="mr-3"  v-if="droitAcces.all_appro_no_valid_dg">
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title   >{{legendeAppro}}</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title class="text-xs-center">
                                            <v-layout wrap>


                                                <v-flex xs12 >
                                                    <v-chip label outline   color="orange darken-1"  class="elevation-4" style="width:90%">
                                                        <span class="subheading">Montant total  à valider: </span> <span class="title"> {{mntTotalAppro}} F Fcfa </span>
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs4 class=" mb-3" >
                                                    <v-chip color="orange" text-color="white" style="font-size:18px" >
                                                        <v-avatar class="orange darken-4">{{nbAppro}}</v-avatar>
                                                        Approvisionnement(s) à valider
                                                    </v-chip>
                                                </v-flex>

                                                <v-flex xs12 >
                                                    <v-layout row class="mb-3" >
                                                        <v-flex xs5  >
                                                            <el-select clearable @clear="clearSelectFour()"  filterable  @change="filtrerFour" v-model="selectFour" placeholder="Facture par fournisseur" style="width:100%">
                                                                <el-option
                                                                        v-for="(item,ind) in listeFournisseurs"
                                                                        :key="ind"
                                                                        :label="item.text"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>

                                            <v-flex xs12>
                                                <data-tables :data="listeDmdNoValidAppro" >
                                                    <el-table-column prop="dateDmd" label="Date" > </el-table-column>
                                                    <el-table-column prop="caisseLibelle" label="Libelle"> </el-table-column>
                                                    <el-table-column prop="montant" label="Montant" >
                                                        <template slot-scope="scope">
                                                            <el-tag>{{scope.row.montant}} FCFA</el-tag>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Action" align="center" fixed="right"  >
                                                        <template slot-scope="scope">
                                                            <v-tooltip top>
                                                                <v-btn slot="activator" @click="modalDetailAppro(scope.row)" fab dark small color="blue">
                                                                    <v-icon dark>list</v-icon>
                                                                </v-btn>
                                                                Detail
                                                            </v-tooltip>
                                                        </template>
                                                    </el-table-column>
                                                </data-tables>
                                            </v-flex>
                                        </v-card-title>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                            <v-layout row>
                                <!-- TABLE DEMANDE ABSENCE -->
                                <v-flex xs12 class="mt-4">
                                    <v-card>
                                        <v-toolbar class="text-xs-center"   color="cyan" dark>
                                            <v-toolbar-title   >LISTE DES DEMANDES DE CONGES</v-toolbar-title>
                                        </v-toolbar>
                                        <v-card-title>
                                            <v-flex xs12>
                                                <listeDemande :statutDemande=1 ></listeDemande>
                                            </v-flex>
                                        </v-card-title>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </el-tab-pane>
                    </el-tabs>
                </v-card>
            </v-flex>
        </v-layout>




         <!-- Dialog de confirmation de la demande suivante -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogValideSuivant" persistent max-width="450">
            <v-card>
                <v-card-title class="headline"> Validation suivante </v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 class="mb-2">
                                <el-alert
                                    title="Voulez-vous passer à la validation suivante ?"
                                    :closable="false"
                                    show-icon
                                    type="warning">
                                </el-alert>
                            </v-flex>
                         </v-layout>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="grey darken-1" dark @click.native="dialogValideSuivant = false">Non</v-btn>
                        <v-btn color="green darken-1" dark  @click.native="SubmitValideSuivant()">Afficher le fiche suivante</v-btn>
                    </v-card-actions>
                </v-card>
                 </v-dialog>
        </v-layout>

        <!-- Dialog de confirmation de la demande suivante -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogValideSuivant" persistent max-width="450">
                <v-card>
                    <v-card-title class="headline"> Validation suivante </v-card-title>
                    <v-card-text>
                        <v-layout wrap>
                            <v-flex xs12 class="mb-2">
                             <el-alert
                                title="Voulez-vous passer à la validation suivante ?"
                                    :closable="false"
                                    show-icon
                                    type="warning">
                                </el-alert>
                             </v-flex>
                            <!-- <v-flex xs12>
                                <p class="grey--text font-weight-thin body-1">DEMANDE</p>
                                <p class="black--text .font-weight-regular subheading" >DMD-{{demandeDetail.idDemande}}</p>
                            </v-flex> -->
                        </v-layout>
                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="CancelValideSuivant()">Non</v-btn>
                <v-btn color="green darken-1" dark  @click.native="SubmitValideSuivant()">Afficher le fiche suivante</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-layout>

         <!-- Dialog de confirmation de la demande suivante -->

             <!-- Detail de la demande de maintenance -->
            <ModalValidationInterv :intervDetail = intervDetail :totalFact= mntTotalIntervTTC  :show =showModalIntervFact  @close="showDialogIntervAfter" ></ModalValidationInterv>
            <!-- Detail de la demande de maintenance -->

            <!-- Detail de la la facture a valider -->
            <ModalValidationFacture :factureDetail = factureDetail :totalFact= mntTotalFactTTC   :show = showModalDetailFact :listCaisse="listCaisse" :listBanque="listBanque"    :commandeDeriv="commandeDeriv"
              :commandeDerivDeux="commandeDerivDeux" :mntTotalCmd="mntTotalCmd" :nbCommandeSug="nbCommandeSug" :nbCommandeSugDeux="nbCommandeSugDeux" @close=" showDialogFactAfter" ></ModalValidationFacture>
            <!-- Detail de la demande de maintenance -->

            <!-- Detail de la demande de maintenance -->
            <ModalValidationDmd :demandeDetail = demandeDetail   :show = showModalDetailDmd @close="showDialogDmdAfter" ></ModalValidationDmd>
            <!-- Detail de la demande de maintenance -->

            <!-- Detail de la demande de mission -->
            <ModalValidationMiss :detailMission = detailMission   :show = showModalDetailMiss @close="showDialogMissAfter" ></ModalValidationMiss>
            <!-- Detail de la demande de mission -->

            <!-- Detail de la demande de fonds -->
            <ModalValidationDmdFond :demandeDetail = demandeDetail :valider='true'  :show = showModalDetailDmdFond @close="showDialogDmdFondAfter" ></ModalValidationDmdFond>
            <!-- Detail de la demande de maintenance -->

            <!-- Detail de l'appro -->
            <ModalValidationAppro :approDetail = ApproDetail :listCaisse="listCaisse" :listBanque="listBanque"  :show = showModalDetailAppro @close="showModalDetailAppro = false; loadDmdNoValidAppro()"></ModalValidationAppro>
            <!-- Detail de l'appro -->

    </div>
</template>

<script>

    import ModalValidationDmd from '@/components/validationDG/ModalValidationDmd'
    import ModalValidationDmdFond from '@/components/validationDG/ModalValidationDmdFond'
    import ModalValidationMiss from '@/components/validationDG/ModalValidationMiss'
    import ModalValidationFacture from '@/components/validationDG/ModalValidationFacture'
    import ModalValidationInterv from '@/components/validationDG/ModalValidationInterv'
    import ModalValidationAppro from '@/components/validationDG/ModalValidationAppro'
    import facturePaiement from "./facturePaiement";
    import listeDemande  from "@/components/resourceHumaine/liste_demande"


    import Loading from '@/components/Loading'

    export default {
        components:{
            facturePaiement,
            Loading,ModalValidationDmd,ModalValidationMiss,ModalValidationFacture,ModalValidationInterv,ModalValidationDmdFond,ModalValidationAppro,listeDemande },
        name: "app",
        data() {
            return {
                //data general
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,
                racourcis: [
                    { path: '/', text: 'Accueil', disabled: false },
                    { path: '/validationDmd', text: 'Dashboard des validations', disabled: true }
                ],


                dialogValideSuivant: false,
                typeDmd: null,
                itemDmd: {},

                // stretch: false,
                //VALIDATION DES sDEMANDES
                listeDemandes:[],
                selectZoneDmd:'',
                oldListDemandes:[],
                legendeDmd: "LISTE DES DEMANDES DE MAINTENANCES A VALIDER",
                comboZoneDmd:[],
                mntTTCAValide: 0,
                demandeDetail: {},
                showModalDetailDmd: false,
                nbDmdMaint:0,


                //VALIDATION MISSIONS
                legendeMiss : "LISTE DES DEMANDES DE MISSION A VALIDER",
                listeMissions:[],
                oldListMissions:[],
                selectMissDemd:"",
                listeDemandeurs: [],
                nbMiss:0,
                mntTotalMissTTC:0,
                detailMission : {},
                showModalDetailMiss : false,

                //VALIDATION FACTURE FOURNISSEUR
                legendeFour : "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER",
                nbFactFour:0,
                listeFournisseurs:[],
                listeFacturesFour: [],
                oldListFacturesFour:[],
                selectFour:'',
                mntTotalFactTTC:0,
                factureDetail:{},
                showModalDetailFact: false,


                //VALIDATION DES DEMANDES APPROVISIONNEMENTS
                legendeAppro : "LISTE DES DEMANDES APPROVISIONNEMENTS",
                mntTotalAppro: 0,
                listeDmdNoValidAppro: [],
                showModalDetailAppro : false,
                ApproDetail:{},
                nbAppro:0,
                listBanque:[],
                listCaisse:[],


                //VALIDATION INTERVENTION
                legendeInterv: "LISTE DES REPARATIONS A VALIDER",
                mntTotalIntervTTC: 0,
                nbInterv: 0,
                selectInterv: '',
                listeDemdInterv: [],
                listeIntervention: [],
                oldListeIntervention: [],
                intervDetail: [],
                showModalIntervFact: false,

                //VALIDATION DENANDE DE FONDS
                legendeDmdFond: "LISTE DES DEMANDES DE FONDS A VALIDER",
                mntTotalDmdFondTTC: 0,
                nbDmdFond: 0,
                selectDmdFond: '',
                listeDemandeurFond: [],
                listeDmdFond: [],
                oldListeDemandeurFond: [],
                dmdFondDetail: [],
                showModalDetailDmdFond: false,
                onglet: "0",

                //VALIDATION DEMANDE CONGE
                listeDemandeurAbs:[],

                //COMPAREUR DE PRIX
                listeProdNull: [],
                mntTotalCmd: 0,
                listeProdNull: [],
                commandeDeriv: [],
                commandeDerivDeux: [],
                nbCommandeSug: 0,
                nbCommandeSugDeux: 0,

            }
        },

        methods: {

            SubmitValideSuivant()
            {
                    switch(this.typeDmd )
                    {
                        case "maintenance":
                            this.dialogValideSuivant = false;
                            this.modalDetailDmd(this.itemDmd)
                            break;

                        case "intervention":
                            this.dialogValideSuivant = false;
                            this.modalDetailInterv(this.itemDmd)
                            break;
                         case "factureFour":
                            this.dialogValideSuivant = false;
                            this.modalDetailFour(this.itemDmd)
                            break;
                         case "mission":
                            this.dialogValideSuivant = false;
                            this.modalDetailMissDemd(this.itemDmd)
                            break;
                        case "demandeFond":
                            this.dialogValideSuivant = false;
                            this.modalDetailDmdFond(this.itemDmd)
                            break;
                    }
            },

             CancelValideSuivant()
            {
                    switch(this.typeDmd )
                    {
                        case "maintenance":
                            this.dialogValideSuivant = false;
                            this.loadDemandeAvalider();
                            break;

                        case "intervention":
                            this.dialogValideSuivant = false;
                            this.loadDmdIntervention();
                            break;
                         case "factureFour":
                            this.dialogValideSuivant = false;
                            this.loadFacture();
                            break;
                         case "mission":
                            this.dialogValideSuivant = false;
                            this.loadMissionsAvalider
                            break;
                         case "demandeFond":
                            this.dialogValideSuivant = false;
                            this.loadDmdFond();
                            break;
                    }
            },


            showDialogDmdAfter(idDmd,type )
            {
                this.showModalDetailDmd = false;
                this.listeDemandes = this.listeDemandes.filter( function(elm){
                    return elm.idDemande != idDmd
                } )

                if(this.listeDemandes.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDemandes[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                }else{
                    this.loadDemandeAvalider();
                }
            },

            showDialogDmdFondAfter(idDmd,type )
            {
                this.showModalDetailDmdFond = false;
                this.listeDmdFond= this.listeDmdFond.filter( function(elm){
                    return elm.id != idDmd
                } )

                if(this.listeDmdFond.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeDmdFond[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                }else{
                    this.loadDmdFond()
                }
            },

             showDialogFactAfter(idDmd,type )
            {
                this.listCaisse= []
                this.listBanque= []
                this.showModalDetailFact = false;
                this.loadFacture()
                this.listeFacturesFour = this.listeFacturesFour.filter( function(elm){
                    return elm.idFact != idDmd
                } )


                if(this.listeFacturesFour.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeFacturesFour[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                }else{
                    this.loadFacture();
                }
            },
            showDialogMissAfter(idDmd,type ){
                this.showModalDetailMiss = false;
                this.listeMissions = this.listeMissions.filter( function(elm){
                    return elm.IdUtil != idDmd
                })

                if(this.listeMissions.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeMissions[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                }else{
                    this.loadMissionsAvalider();
                }
            },
            showDialogIntervAfter(idDmd,type )
            {
                this.showModalIntervFact = false;
                this.listeIntervention = this.listeIntervention.filter( function(elm){
                    return elm.intervId != idDmd
                } )


                if(this.listeIntervention.length != 0) //verifions s'il y a une element a valider dans la liste
                {
                    this.itemDmd = this.listeIntervention[0];
                    this.typeDmd = type;
                    this.dialogValideSuivant = true;
                }else{
                    this.loadDmdIntervention()
                }
            },

            //DEMANDE DE MAINTENANCE
            modalDetailDmd(item)
            {
              this.demandeDetail = item
              this.showModalDetailDmd = true
            },
            filtrerZoneDmd(idZone){
                this.loadDmdParZone(idZone)
            },
            loadLieu() {
                let url = this.domaine +  'validationDG/lieu'
                this.$http.get(url).then(response => {
                this.comboZoneDmd = response.body.lieux;
                },
                erreurRep => {
                })
            },
            loadDmdParZone(idZone) {
                this.legendeDmd  = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER FILTREES PAR ZONE";
                this.listeDemandes = this.oldListDemandes
                 this.listeDemandes = this.listeDemandes.filter(function (item) {
                  return item.idZone == idZone
                })
            },
            clearSelectDmdZone(){
                this.listeDemandes = this.oldListDemandes;
                this.legendeDmd = "LISTE DES DEMANDES DE MAINTENANCES A VALIDER";
            },
            loadDemandeAvalider() {
                this.loading = true;
                let url = this.domaine +  'validationDG/index/demandes'
                this.$http.get(url).then(response => {
                    this.oldListDemandes = response.body.listeDemandes
                    this.listeDemandes = response.body.listeDemandes

                    this.mntTTCAValide =  response.body.mntTTC
                    this.nbDmdMaint =  response.body.nbMaint
                    this.loadLieu()
                    this.loading = false;
                },
                (erreur) => {
                     this.loading = false
                     this.$message.error("Une erreur est survenue lors du chargement des demandes de maintenances'")
                })
                },

                //DEMANDE DE MISSION
                 filtrerMissDemd(idDemd)
                {
                    this.loadMissionDemd(idDemd)
                },


                 clearSelectMissDemd(){
                     this.listeMissions = this.oldListMissions;
                    this.legendeMiss = "LISTE DES DEMANDES DE MISSION A VALIDER";
                },
                   loadMissionDemd(idDemd) {
                this.legendeMiss  = "LISTE DES DEMANDES DE MISSION A VALIDER FILTREES PAR DEMANDEUR";
                this.listeMissions = this.oldListMissions
                 this.listeMissions = this.listeMissions.filter(function (item) {
                  return item.idUserDemandeur == idDemd
                })
            },
            loadMissionsAvalider()
            {
                let url = this.domaine + "validationDG/index/missions";
                this.$http.get(url).then(
                    resp => {
                        this.oldListMissions = resp.body.missions,
                        this.listeMissions = resp.body.missions,
                        this.nbMiss = resp.body.nbUtil,
                        this.listeDemandeurs = resp.body.listeDemandeurs
                        this.mntTotalMissTTC = resp.body.mntTotalTTC

                    },
                    resp => {
                        this.$message.error(
                            "erreur lors du chargement des missions."
                        );
                    }
                );
            },
            modalDetailMissDemd(item){
                this.detailMission = item
                this.showModalDetailMiss = true
            },

            //FACTURE FOURNISSEUR
            clearSelectFour(){
                this.listeFacturesFour = this.oldListFacturesFour;
                this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
            },
            modalDetailFour(item){
                this.listBanque = []
                this.listCaisse = []
                if(item.listBanque.length == 0) {
                  this.loadAllBanque()
                }else{
                   this.listBanque = item.listBanque
                   this.listCaisse = item.listCaisse
                }
                console.log('okeke',item)
                this.factureDetail= item
                this.showModalDetailFact = true
                 this.showModalDetailFact = true
                this.commandeDerivDeux = []
                this.commandeDeriv = []
                this.showDialogComparaison(item)
            },

                 modalDetailDmdFond(item){
                    this.demandeDetail = item
                    this.showModalDetailDmdFond = true
                },

                //FACTURE FOURNISSEUR
                 clearSelectFour(){
                    this.listeFacturesFour = this.oldListFacturesFour;
                    this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
                } ,
                 showDialogComparaison(item) {
                    // this.loading = true;
                      let smsAficher =
                        "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
                      let mesProdPrixNulle =
                        "Les produits de cette commande ne se trouvent chez aucun autres de vos fournisseurs ";

                    var formdata = new FormData();
                      let url = this.domaine + "comparateur/new/commande";
                      let options = [];
                      let listProdPrixNulle = [];

                        for (let prop in item.option) {
                          let ligne = item.option[prop];
                            options.push(ligne.id);
                        }

                      formdata.append("options", options);
                      formdata.append("facture", 1);
                      formdata.append("typeOption", 2); //optionBesoin

                    this.$http.post(url, formdata).then(
                      response => {

                        //affichage des messages
                        let nbCmd = 0;
                        let nbCmdDeux = 0
                        let listeFoun = [];
                        let listeNull = [];
                        let listeFounSecond = []
                        // if (response.body.code == 1) {


                        // } else {

                          const respFour = response.body.fournisseurs[0];
                          this.mntTotalCmd = response.body.mntTotauxFormat;
                          this.listeProdNull = response.body.listeProdNull;
                          // if (respFour.length == 0) {
                          //     this.loading = false;
                          //     this.$alert(mesProdPrixNulle, "", {
                          //       confirmButtonText: "OK"
                          //     });
                          //     return
                          //   }

                            this.loading = false;
                          for (let four in respFour) {
                            let listeProduit = respFour[four];

                            let infoFour = {
                              fournisseur: four,
                              produits: [],
                              mntTotal: 0,
                              mntTotalHt: 0,

                            };
                            for (let produit of listeProduit) {
                              infoFour.produits.push(produit);
                              infoFour.mntTotal += parseFloat(produit.mntTotal);
                              infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                            }
                                if(infoFour.produits.length == options.length)
                                {
                                  nbCmd++;
                                  listeFoun.push(infoFour);
                                }else{
                                  nbCmdDeux++;

                                  listeFounSecond.push(infoFour);
                                }


                          }

                          this.nbCommandeSug = nbCmd;
                          this.commandeDeriv = listeFoun;
                          this.nbCommandeSugDeux = nbCmdDeux;
                          this.commandeDerivDeux = listeFounSecond;
                          // this.dialogDetailCmd = true;
                          this.loading = false;
                          //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
                          if (response.body.listeProdNull.length > 0) {
                            // this.dialogProdNull = true;
                            //this.closeProdNull();
                          }

                          if (listeFoun.length > 0) {
                            this.showModalCompCmd = true;
                          }
                        // }
                      },
          error => {
            this.loading = false;
            this.$message.error("Erreur serveur");
          }
      );
    },
        filtrerFour()
        {
            // this.loadFactParFour(this.selectFour)
            let tab = this.listeFournisseurs
            let newTab = []
            this.listeFournisseurs= tab.filter(item=>{
              if(item.value == this.selectFour){
                  newTab.push(item)
              }
              return newTab
            })
        },

            modalDetailAppro(item){
                this.ApproDetail= item
                this.showModalDetailAppro = true
                this.loadListBanque(item.caisseId)
                this.loadListCaisse(item.caisseId)
            },
            loadListBanque (item){
                this.loading = true
                let url = this.domaine + 'caisse/tresor/'+ item +'/banque'
                this.$http.get(url).then(response => {
                    this.listBanque = response.body.listBanque
                    this.loading = false
                },errResp=>{
                     this.loading = false
                      this.$message.error("Une erreur est survenue lors du chargement de la liste banque")
                })
            },
            loadListCaisse (item){
                this.loading = true
                let url = this.domaine + 'caisse/tresor/'+ item +'/caisse'
                this.$http.get(url).then(response => {
                    this.listCaisse = response.body.listCaisse
                    this.loading = false
                },errResp=>{
                     this.loading = false
                      this.$message.error("Une erreur est survenue lors du chargement de la liste caisse")
                })
            },
            loadAllBanque (){
                this.loading = true
                let url = this.domaine + 'caisse/tresor/banque'
                this.$http.get(url).then(response => {
                    this.listBanque = response.body.listBanque
                    this.listCaisse = response.body.listCaisse
                    this.loading = false
                },errResp=>{
                     this.loading = false
                      this.$message.error("Une erreur est survenue lors du chargement de la liste banque")
                })
            },
            loadAllCaisse (){
                this.loading = true
                let url = this.domaine + 'caisse/tresor/caisse'
                this.$http.get(url).then(response => {
                    this.listCaisse = response.body.listCaisse
                    this.loading = false
                },errResp=>{
                     this.loading = false
                      this.$message.error("Une erreur est survenue lors du chargement de la liste caisse")
                })
            },

            loadFactParFour(idFour) {
                this.legendeFour  = "LISTE DES DEVIS / FACTURES A VALIDER FILTREES PAR FOURNISSEUR";
                this.listeFacturesFour = this.oldListFacturesFour
                 this.listeFacturesFour = this.listeFacturesFour.filter(function (item) {
                  return item.idUserDemandeur == idFour
                })
            },
            loadFacture () {
                this.loading = true
                let url = this.domaine + 'validationDG/fournisseur/facture';
                this.$http.get(url).then(response => {
                this.listeFournisseurs = response.body.listeFour
                this.mntTotalFactTTC = response.body.totalFacture
                this.nbFactFour = response.body.nbFact
                this.listeFacturesFour = response.body.facture;
                this.oldListFacturesFour = response.body.facture;
                this.loading = false
                },
                resp => {
                    this.$message.error(
                        "erreur lors du chargement des devis / factures fournisseurs."
                    );
                })
            },

            // INTERVENTION
            modalDetailInterv(item){
                this.intervDetail= item
                this.showModalIntervFact = true
            },
            clearSelectInterv(){
                this.listeIntervention = this.oldListeIntervention;
                this.legendeInterv = "LISTE DES REPARATIONS A VALIDER";
            },
            filtrerInterv(idDemandeur){
                 this.loadDmdParInterv(idDemandeur)
            },
            loadDmdParInterv(idDemandeur){
                this.legendeInterv  = "LISTE DES REPARATIONS A VALIDER FILTREES PAR DEMANDEUR";
                this.listeIntervention = this.oldListeIntervention
                this.listeIntervention = this.oldListeIntervention.filter(function (item) {
                return item.idDemandeur == idDemandeur
                })
            },
            loadDmdIntervention(){
                this.loading = true
                let url = this.domaine + 'validationDG/intervention/facture'
                this.$http.get(url).then(response => {
                this.listeIntervention = response.body.listeInterv
                this.oldListeIntervention = response.body.listeInterv;
                this.mntTotalIntervTTC = response.body.mntTotal
                this.nbInterv = response.body.nbInterv
                this.listeDemdInterv = response.body.listeDemdInterv;
                this.loading = false
                },
                 resp => {
                        this.$message.error(
                            "erreur lors du chargement des demandes reparations."
                        );
                    })
            },

            //demande de fonds

                 filtrerDmdFond(idDemd)
                {
                    this.loadDmdFond(idDemd)
                },


             loadDmdFond(){
                this.loading = true
                let url = this.domaine + 'validationDG/dmdFond/liste'
                this.$http.get(url).then(response => {
                this.listeDmdFond = response.body.listeDmdFond
                this.oldListeDmdFond = response.body.listeDmdFond;
                this.mntTotalDmdFondTTC = response.body.mntTotal
                this.nbDmdFond= response.body.nbDmdFond
                this.listeDemandeurFond = response.body.listeDemandeurFond;
                this.loading = false
                },
                 resp => {
                         this.loading = false
                        this.$message.error(
                            "erreur lors du chargement des demandes de fonds."
                        );
                    })
            },

            // DEMANDE D'APPROVISIONNEMENT
            loadDmdNoValidAppro(){
                this.loading = true
                let url = this.domaine + 'caisse/appro/no-valide-dg/all'
                this.$http.get(url).then(response => {
                    this.listeDmdNoValidAppro = response.body.appro
                    this.mntTotalAppro = response.body.totDmdAppro
                    this.nbAppro = response.body.nbAppro
                    this.loading = false
                },
                resp => {
                    this.$message.error(
                        "erreur lors du chargement des demandes approvisionnement."
                    );
                })
            },
            handleTabClick(tab){

            },

            //DEMANDE DE CONGE
            clearSelectDmd(){
                this.listeFacturesFour = this.oldListFacturesFour;
                this.legendeFour = "LISTE DES DEVIS / FACTURES FOURNISSEURS A VALIDER";
            },






        },

        mounted() {
            this.loadDemandeAvalider()
            this.loadMissionsAvalider()
            this.loadFacture()
            this.loadDmdIntervention()
            this.loadDmdFond()
            this.loadDmdNoValidAppro()
        }
    };
</script>

<style scoped>
    .toolbar_content {
        height:37px;
    }
</style>



// WEBPACK FOOTER //
// src/components/validationDG/Validation_index.vue